import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { Post } from '@cms/interfaces/post';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import PostDetails from '@cms/components/details/post-details/post-details.vue';
import PostForm from '@cms/components/forms/post-form/post-form.vue';
import TranslatableModal from '@core/components/modals/translatable-modal.vue';

library.add(faSync);

@Component({
  name: 'bpc-post-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-post-form': PostForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-post-details': PostDetails,
    'bpc-translatable-modal': TranslatableModal,
  },
})
export default class PostTable extends mixins(AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    translatableModal: InstanceType<typeof TranslatableModal> & {
      onOpenModal(): void;
      onCloseModal(): void;
    };
  };
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop(String) readonly managementType: string;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly createFormConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly updateFormConfigName: string;

  public entity: Post = null;
  public entityName = 'post';
  public pluralEntityName = 'posts';
  public postDetailsModalTitle = '';

  public flagsToCheckBeforeLoadEntities: Array<any> = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
    'filtersLoaded',
    'urlParametersLoaded',
  ];

  public customRowActions = {
    details: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      text: 'details',
      event: 'details',
    },
  };

  get dynamicFormConfigName() {
    if (this.managementType === 'post-pages') {
      return this.entity?.id ? this.updateFormConfigName : this.createFormConfigName;
    } else {
      return this.formConfigName;
    }
  }

  get totalAvailableLanguages() {
    return this.$store.getters['centerSettings/totalAvailableLanguages'];
  }

  openTranslatableModal(): void {
    this.$refs.translatableModal.onOpenModal();
  }

  customOnRowAction($event: { event: string; item: any }) {
    const actionName = $event.event === 'public-details' ? 'publicDetails' : $event.event;
    if ($event.item.item.actions[actionName].activated) {
      switch ($event.event) {
        case 'details':
          this.$router.push({
            name: 'public-post-details',
            params: { alias: $event.item.item.alias },
          });
          break;
      }
    }
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Post;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onShow(e) {
    this.$bvModal.show('modal-post-details');
    this.entity = e.item;
    this.postDetailsModalTitle = this.$t('global.post_preview') as string;
  }

  getModalTitle() {
    if (this.disabledForm) {
      const title = this.$t('global.models.' + this.managementType + '.name').toString();
      return title.charAt(0).toUpperCase() + title.slice(1); // capitalize
    } else if (this.entity && this.entity.id) {
      return (
        this.$t('global.modals.edit') +
        ' ' +
        this.$t('global.models.' + this.managementType + '.name')
      );
    } else {
      return (
        this.$t('global.modals.create') +
        ' ' +
        this.$t('global.models.' + this.managementType + '.name')
      );
    }
  }
  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
